import type { DateFieldProps } from "./FormFields.interface";

export default function DateField({
  label,
  value,
  onChange,
  invalid,
}: DateFieldProps) {
  return (
    <div className={`form-field ${invalid ? "invalid" : ""}`}>
      <label>{label}</label>
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
